export interface BwmConfig {
    readonly categories: Category[];
}
export interface Category {
    readonly active: Active;
    readonly id: string;
    readonly fields?: Field[];
}

export interface Field {
    readonly ref: string;
    readonly active: Active;
    readonly mandatory: Active;
    readonly maxFileSize?: number;
    readonly maxFiles?: number;
    readonly minFiles: MinFile[];
    readonly allowedFileExtensions: string[];
}

export interface MinFile {
    readonly mandatory: Active;
    readonly keyDokument: string;
}

export enum Active {
    N = 'n',
    Y = 'y',
}

export enum FieldDatatype {
    AUTOCOMPLETE,
    INPUT,
    INPUTNUMBER,
    CURRENCY,
    DECIMAL,
    PERCENT,
    CALENDAR,
    CHECKBOX
}
